import {FonteDadosProxyRotaAbstract} from './fonte-dados-proxy-rota-abstract.model';
import {
  FonteDadosProxyParametroBody,
  FonteDadosProxyParametroConfig,
  FonteDadosProxyParametroTipo
} from './fonte-dados-proxy-parametro';

export class FonteDadosProxyRotaPessoaMetadados extends FonteDadosProxyRotaAbstract {

  rota: string;

  constructor() {
    super('recuperarPessoasMetadadosPorIds', 'POST');
    this.criarParametrosQuery();
    this.criarParametroBody();
  }

  private criarParametrosQuery() {
    const configPadrao: FonteDadosProxyParametroConfig = {
      tipo: FonteDadosProxyParametroTipo.BOOLEAN,
      valor: true
    };
    this.adicionarParametroQuery('incluirDocumentos', 'Incluir Documentos', configPadrao);
    this.adicionarParametroQuery('incluirEnderecos', 'Incluir Endereços', configPadrao);
    this.adicionarParametroQuery('incluirEnderecosEletronicos', 'Incluir Endereços Eletrônicos', configPadrao);
    this.adicionarParametroQuery('incluirOutrosNomes', 'Incluir Outros Nomes', configPadrao);
    this.adicionarParametroQuery('incluirRelacionamentos', 'Incluir Relacionamentos', configPadrao);
    this.adicionarParametroQuery('incluirTelefones', 'Incluir Telefones', configPadrao);
  }

  private criarParametroBody() {
    const pessoasIds = new FonteDadosProxyParametroBody('pessoasIds', true);
    pessoasIds.rotulo = 'Pessoas IDs';
    pessoasIds.titulo = 'Lista com os identificadores das pessoas';
    pessoasIds.tipo = FonteDadosProxyParametroTipo.CHIPS;
    this.adicionarParametroBody(pessoasIds);
  }

  limparValores() {
    super.limparValores();
    this.parametrosQuery.forEach(pq => pq.valor = true);
  }


  body(): any {
    const pessoasIds = this.parametrosBody.find(paramBody => paramBody.nome === 'pessoasIds');
    if (pessoasIds && pessoasIds.valor) {
      const resultado = pessoasIds.valor
        .map((v: string) => v ? v.trim() : null)
        .filter((v: string) => v !== null && v !== '');
      return [...new Set(resultado)];
    }
    else {
      return null;
    }
  }
}
